import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import Loader from "../../../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";

export const SendInvoiceModal = ({
  sendInvoice,
  setSendInvoice,
  getPreliminaryInvoices,
  resendMail,
  setResendMail,
  setgetErrorMessages,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const language = localStorage.getItem("i18nextLng");

  const handleSendInvoice = async () => {
    setLoading(true);

    const { fetchPreliminaryInvoices } = sendInvoice;
    const data = fetchPreliminaryInvoices;

    const totalWorkingDates = [];
    data?.invoiceApprovalWorkingHours.forEach((items, index) => {
      totalWorkingDates.push({
        id: 0,
        workingDate: items?.workingDate,
        number: items?.number,
        unit: items?.unit,
        amountPerUnit: items?.amountPerUnit,
        articleNumber: items?.articleNumber,
        workingDescription: items?.workingDescription,
        houseworkType: items?.houseworkType,
        userId: items?.userId,
        workingHour: items?.workingHour,
      });
    });

    let file = [];
    if (data?.invoiceApprovalFilesUpload.length > 0) {
      data?.invoiceApprovalFilesUpload.forEach((item, index) => {
        file.push({
          fileName: item?.fileName,
          fileContent: item?.fileContent || item?.uploadfileForInvoice,
          userId: item?.userId,
        });
      });
    }

    let invoiceFreelancerArr = [];

    if (data?.invoiceApprovalFreelancers?.length > 0) {
      data?.invoiceApprovalFreelancers.forEach((item, index) => {
        invoiceFreelancerArr.push({
          amount: item?.amount,
          userId: item?.userId,
        });
      });
    }

    try {
      const res = await axios.post("/invoice", {
        approvalInvoiceId: data?.id,
        invoiceId: 0,
        sendInvoice: 1,
        vat: data?.vat,
        pension: data?.pension,
        amount: parseFloat(data?.amount),
        isFixed: data?.isFixed,
        currency: data?.currency,
        brfNo: data?.brfNo || "",
        registerAssignment: false,
        showDates: data?.showDates,
        house: data?.house || false,
        holidaySavings: data?.holidaySavings,
        description: data?.description,
        taxValue: data?.tax,
        totalToPay: data?.toPayAmont,
        rutDeduction: data?.rutDeduction,
        rootDeduction: data?.rotDeduction,
        file: file.length > 0 ? file : null,
        expressPayout: data?.expressPayout,
        workingHours: [...totalWorkingDates],
        email: data?.customer.email,
        apartment: data?.apartment || false,
        pensionFee: data?.pensionFee ? data?.pensionFee : 0,
        holidaySavingsFee: data?.holidaySavingsFee
          ? data?.holidaySavingsFee
          : 0,
        tax: parseInt(data?.tax),
        rotApartmentNo: data?.rotApartmentNo || "",
        pensionAmount: data?.pensionAmount || 0,
        customerId: data?.customer?.customerId,
        forpAmount: data?.forpAmount,
        holidaySavingsAmount: data?.holidaySavingsAmount,
        amountIncVat: parseFloat(Math.round(data?.amountIncVat)),
        secondaryEmailAddress: data?.customer?.secondaryEmailAddress,
        multipleFreelancer: data?.multipleFreelancer,
        currencyRate: data?.currencyRate,
        invoiceFreelancer:
          invoiceFreelancerArr?.length > 0
            ? invoiceFreelancerArr
            : [
                {
                  amount: 0,
                  userId: 0,
                },
              ],
      });

      if (res?.status === 200) {
        toast.success(t("Invoice has been successfully sent"));
        setSendInvoice((prevState) => ({
          ...prevState,
          show: false,
        }));
        getPreliminaryInvoices();
      } else {
        toast.error(t("Server Error, Please contact Administrator"));
      }
    } catch (err) {
      setLoading(false);
      setgetErrorMessages(err?.response?.data?.message);
      setSendInvoice((prevState) => ({
        ...prevState,
        show: false,
      }));
    } finally {
      setLoading(false);
    }
  };

  const handleResendMail = async () => {
    setLoading(true);
    const { data } = resendMail;
    let file = [];
    if (data?.invoiceApprovalFilesUpload.length > 0) {
      data?.invoiceApprovalFilesUpload.forEach((item, index) => {
        file.push({
          fileName: item?.fileName,
          fileContent: item?.fileContent,
        });
      });
    }

    try {
      const payload = {
        id: data?.id,
        invoicePdf: data?.invoicePdfS,
        lang: language,
      };
      const res = await axios.post(
        "/invoice/send-approval-invoice-pdf",
        payload
      );
      if (res.status === 200) {
        setLoading(false);

        toast.success(t(res?.data?.response));
        setResendMail((prevState) => ({
          ...prevState,
          show: false,
        }));
      } else {
        toast.error(t("Server Error, Please contact Administrator"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : error?.response?.data?.title
      );
    }
  };
  return (
    <div>
      {loading && <Loader />}

      <Modal
        show={true}
        onHide={() =>
          resendMail?.show
            ? setResendMail((prev) => ({
                ...prev,
                show: false,
              }))
            : setSendInvoice((prevState) => ({
                ...prevState,
                show: false,
              }))
        }
      >
        <Modal.Header>
          <Modal.Title>
            {resendMail?.show ? t("Resend email") : t("Create Invoice")}
          </Modal.Title>
          <AiOutlineClose
            className="ml-auto cursor-pointer"
            size={24}
            onClick={() =>
              resendMail?.show
                ? setResendMail((prev) => ({
                    ...prev,
                    show: false,
                  }))
                : setSendInvoice((prevState) => ({
                    ...prevState,
                    show: false,
                  }))
            }
          />
        </Modal.Header>
        <Modal.Body>
          {resendMail?.show
            ? t("Are you sure you want to resend mail?")
            : t("Are you sure you want to create invoice?")}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="outline_btn_new"
            variant="secondary"
            onClick={() =>
              resendMail?.show
                ? setResendMail((prev) => ({
                    ...prev,
                    show: false,
                  }))
                : setSendInvoice((prevState) => ({
                    ...prevState,
                    show: false,
                  }))
            }
          >
            {t("No")}
          </button>
          <Button
            className="text-light delete_customer new_theme_btn "
            variant="primary"
            onClick={resendMail?.show ? handleResendMail : handleSendInvoice}
          >
            {t("Yes")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
